import React from 'react';
import PropTypes from 'prop-types';
function LtsContentSection({ sectionTitle, paraContentCollection }) {
  return (
    <section className="appendBottom20">
      {sectionTitle && <h2 className="appendBottom5">{sectionTitle}</h2>}
      <p>
        {paraContentCollection.map((spanContent) => (
          <span className="latoRegular" dangerouslySetInnerHTML={{ __html: spanContent }} />
        ))}
      </p>
    </section>
  );
}

LtsContentSection.propTypes = {
  sectionTitle: PropTypes.string,
  paraContentCollection: PropTypes.string
};

export default LtsContentSection;
